import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapHelper from '../../../services/TapHelper';
import TapIcon from '../../../services/TapIcon';
import PageHeader from '../../includes/PageHeader';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import DateService from '../../../services/DateService';
import moment from 'moment';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';
import download from '../../../services/DownloadFile';


const SubAssemblySummaryReport              =   forwardRef((props, ref) => {
    
    let initListData                        =   {
        loading                                 :   false,
        data_loaded                             :   false,
        show                                    :   false,
        items                                   :   [],
        page                                    :   1
    };
    
    let initFormData                        =   {
        show                                    :   true,
        per_page                                :   50,
        form_data_loaded                        :   false,
        loading                                 :   false,
        downloading                             :   false,
        category                                :   [],
        search_category_id                       :   '',
        selected_assets                         :   [],
        search_asset_ids                        :   [],
        sites                                   :   [],
        allStatus                               :   [],
        search_site_ids                         :   [],
        search_tags                             :   [],  
        search_status_ids                        :   [], 
        search_serial_number                    :   '',
        linkingStatus                           :   [],
        search_linking_status                   :   '',
        sub_assembly_tags                       :   [],
        // date_range                              :   '',
        // date_range_start                        :   '',
        // date_range_end                          :   '',
        periods                                 :   [],
        search_ids                 :   [],


    };

    let formDataLabel                       =   {
        search_status_ids                       :   'Status : ',
        search_category_id                      :   'Cateogry  : ',
        search_site_ids                         :   'Sites : ',
        search_tags                             :   'tags : ',
        search_serial_number                    :   'Serial Number : ',
        search_linking_status                   :   'Linking Status : ',
        search_asset_ids                        :   'Asset Name : ' ,
        // date_range                              :   'Transaction Period :  ',
        search_ids                 :   'Sub Assemblies : ',


    };
    const criteriaRef                           =   useRef()
    const access_token                          =   useSelector(state => state.auth.access_token);
    const all_periods                           =   useSelector(state => state.app.all_periods)|| [];
    const user_sites                            =   useSelector(state => state.app.user_sites ? state.app.user_sites : []);
    const linkingStatusData                     =   [ {value : 'Y', label : 'Yes'}, {value: 'N', label : 'No'}]
    let itemListUrl                             =   IAM_API_BASE_URL_2 + "/report/sub_assembly_summary";

    const [subAssemblyData, setSubAssemblyData]         =   useState(initListData);
    const [formData, setFormData]                       =   useState(initFormData);
    const [searchedElems, setSearchedElems]             =   useState([]);
    const [criteriaHeight, setCriteriaHeight]           =   useState(0)
    const [searchedSubassembly, setSearchedSubassembly] =   useState([])

    useEffect(() => {
        updateCriteriaHeight()
    }, [subAssemblyData.show]);
    useEffect(() => {
        toggleFilterForm(true);
        loadFormData()
    }, []);
    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };


    const toggleFilterForm                  =   (show)      => {
        setFormData(pd => ({...pd, show : show }));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
 
    }

    const loadFormData = () => {
        setFormData(pd => ({
            ...pd,
            form_data_loaded: true,
        }))
        HttpAPICall.withAthorization('GET', itemListUrl, access_token, { action: "formData" }, {}, (resp) => {
            let data = resp.data;

            setFormData(pd => ({
                ...pd,
                allStatus: data.sub_assembly_status.map((s) => { return { value: s.id, label: s.name } }),
                category: data.sub_assembly_categories.map((s) => { return { ...s, value: s.id, label: s.name } }),
                sites: user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }),
                sub_assembly_tags: data.tags && data.tags.length > 0 ? data.tags.map((tag) => { return { value: tag, label: tag }; }) : [],
                linkingStatus: linkingStatusData.map((s) => { return { value: s.value, label: s.label } }),
                periods:  [...all_periods, { key: 'custom', display: 'Custom Date Range' }],
            }))
        }).then(() => {
            setSubAssemblyData(pd => ({ ...pd, form_data_loaded: false }));
        })
    }

    const closeReport                       =   ()          => props.history.push({pathname: `/report`})

    const submitSearchFormHandler           =   (e)         => {
        e.preventDefault();

        toggleFilterForm(false);

        let searchedElems               =   [];
        let searchParams                =   {};
        Object.keys(formData).map((key)     =>  {
            let label                       =   formDataLabel[key];
            let value                       =   formData[key];
           if(value !== null && value !== undefined && value !== '' && 
           !(Array.isArray(value) && value.length === 0)) {
                searchParams[key]       =   value;
                if (label) {
                    let show_val        =   value;
                    if(key == 'search_asset_ids') {
                        show_val            =   formData.selected_assets ? formData.selected_assets.map(s => s.display_label).join(', ') : '';
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   formData.sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_tags') {
                        show_val            =   formData.sub_assembly_tags.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    
                    if (key === 'search_status_ids') { 
                        show_val = formData.allStatus.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                   
                    if (key == 'search_category_id') {
                        const category = formData.category.find(s => s.value == value);
                        show_val = category ? category.label : value;

                    }
                    if (key === 'search_linking_status') {
                        show_val = formData.linkingStatus.filter((l) => value.includes(l.value)).map(l => l.label).join(', ');
                    }
                      if(key == 'search_ids') {
                        show_val            =   searchedSubassembly ? searchedSubassembly.map(s => s.label).join(', ') : '';
                    }
                    if (key === 'search_serial_number') { 
                        show_val = formData.search_serial_number
                    }
                    // if (key == 'date_range') {
                    //     if (value === 'custom') {
                    //         const start = formData.date_range_start;
                    //         const end = formData.date_range_end;
                    //         show_val = `Custom Date Range (${moment(start).format('DD-MMM-YYYY')} - ${moment(end).format('DD-MMM-YYYY')})`;
                    //     } else {
                    //         show_val = formData.periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date);
                    //     }
                    // }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        setSearchedElems(searchedElems);
        loadsubAssemblyData(1);
    }                      

    const loadsubAssemblyData               =   (page = 1)  =>  {
        setSubAssemblyData(pd => ({ ...pd, show: true, data_loaded: false, loading: true, page: page }));
        let params = {
            action: 'data',
            page: page,
            ...TapHelper.pick(formData, ['search_tags', 'search_status_ids', 'search_site_ids', 'search_asset_ids', 'search_site_ids','search_linking_status', 'search_serial_number',
                // 'date_range','date_range_start','date_range_end',
                'search_category_id','search_ids'])
        };
        Object.keys(params).forEach(key => {
            if (params[key] === null || params[key] === undefined ||
                (Array.isArray(params[key]) && params[key].length === 0) ||
                params[key] === "") {
                delete params[key];
            }
        });
        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            let respData                =   response.data;
            let meta                    =   TapHelper.pick(respData, ['from', 'to', 'total', 'last_page','per_page','current_page']);
            setSubAssemblyData(pd => ({...pd, data_loaded : true, items : respData.data, meta : meta,  }));
        }).then(() => {
            setSubAssemblyData(pd => ({...pd, loading : false}));
        });
    }

    const reportDownloadHandler             =   ()          =>  {
        let params                      =   {
            action : 'download',
            ...TapHelper.pick(formData, ['search_tags', 'search_status_ids', 'search_site_ids', 'search_asset_ids', 'search_site_ids','search_serial_number','search_linking_status',
                // 'date_range','date_range_start','date_range_end',
                'search_category_id','search_ids']),
            // date_range: formData.date_range == "" ? "current_quarter" : formData.date_range

        };
        setSubAssemblyData(pd => ({...pd, downloading : true }));
        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
           download.file(null,response.data.msg,response.data.navigation,props)
        }).then(() => {
            setSubAssemblyData(pd => ({...pd, downloading : false}));
        });
    }
    const tapSelectChange = (selectedOption, formName, fieldName) => {
        const value = Array.isArray(selectedOption) ?
            selectedOption.map(option => option.value) :
            (selectedOption ? selectedOption.value : '');

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    const filterFormJsx = () => {
        return (
            <>
                    <form onSubmit={submitSearchFormHandler} className='py-3'>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label text-end">Sub Assembly</label>
                        <div className="col-sm-6">
                            <InputSubAssemblySearch
                                changeEvent={(selectedOption) => {
                                    tapSelectChange(selectedOption, 'formData', 'search_ids');
                                    setSearchedSubassembly(selectedOption && selectedOption.length > 0 ? selectedOption : [])
                                }}
                                placeholder="Search Sub Assembly"
                                isMulti={true}
                                value={searchedSubassembly.length > 0 ? searchedSubassembly.map(a => { a.label = a.label; return a; }) : []}
                            />
                        </div>
                    </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Status</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.allStatus}
                                    changeEvent={selectedOptions => {
                                        setFormData(d => ({
                                            ...d,
                                            search_status_ids: selectedOptions ? selectedOptions.map(o => o.value) : []
                                        }));
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={formData.allStatus.filter(s => formData.search_status_ids.includes(s.value))}
                                    placeholder="Select Status"
                                    isMulti={true}
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-3 col-form-label text-end">Serial Number</label>
                            <div className="col-sm-6">
                                <input
                                    name="search_serial_number"
                                    type="text"
                                    value={formData.search_serial_number}
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Enter Serial Number"
                                    onChange={(e) => setFormData(d => ({ ...d, search_serial_number: e.target.value }))}
                                />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Cateogry</label>
                            <div className="col-sm-6">
                               <TapSelect
                                options={formData.category}
                                changeEvent={so => {
                                    setFormData(d => ({
                                        ...d,
                                        search_category_id: so ? so.value : '',
                                    }));
                                }}
                                isSearchable={true}
                                isClearable={true}
                                value={formData.category.find(s => formData.search_category_id == s.value) || null}
                                placeholder="Select Category"
                            />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Linked Status</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.linkingStatus}
                                    changeEvent={o => { setFormData(d => ({ ...d, search_linking_status: o ? [o.value] : [] })) }}
                                    isSearchable={true}
                                    isClearable={true}
                                    menuPlacement="bottom"
                                    value={formData.linkingStatus.find(s => formData.search_linking_status.includes(s.value)) || null}
                                    placeholder="Select Linked Status"
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-3 col-form-label text-end">Assets</label>
                            <div className="col-sm-6">
                                <InputAssetSearch
                                    placeholder="Search Assets"
                                    filter={true}
                                    isMulti={true}
                                    value={formData.selected_assets ? [...formData.selected_assets] : []}
                                    changeEvent={(so) => {
                                        setFormData(d => ({
                                            ...d,
                                            search_asset_ids: so ? so.map(s => s.value) : [],
                                            selected_assets: so && so.length > 0 ? so.map(a => { a.label = a.display_label; return a; }) : []
                                        }));
                                    }} />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Site Name</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    changeEvent={o => setFormData(d => ({ ...d, search_site_ids: o.map(e => e.value) }))}
                                    placeholder="Select Sites"
                                    isClearable={true}
                                    isSearchable={true}
                                    options={formData.sites}
                                    value={formData.sites.filter(s => formData.search_site_ids.includes(s.value))}
                                    isMulti={true}
                                />
                            </div>
                        </div>
                        <div className="row my-3">
                            <label className="col-sm-3 col-form-label text-end">Tags</label>
                            <div className="col-sm-6">
                                <TapSelect
                                    options={formData.sub_assembly_tags}
                                    changeEvent={o => setFormData(d => ({ ...d, search_tags: o.map(e => e.value) }))}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={true}
                                    value={formData.sub_assembly_tags.filter(s => formData.search_tags.includes(s.value))}
                                    placeholder="Select Tags"
                                />
                            </div>
                        </div>
                        {/* <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Transaction Period</label>
                        <div className="col-sm-6">
                            <PeriodSelectionWithCustom
                                periods={formData && formData.periods ? formData.periods : []}
                                value={formData.date_range}
                                startDate={formData.date_range_start}
                                endDate={formData.date_range_end}
                                onSelectPeriod={(period, startDate, endDate) => {
                                    setFormData({
                                        ...formData, date_range: period, date_range_start: startDate, date_range_end: endDate
                                    })
                                }}
                            />
                        </div>
                    </div> */}
                    <div className="row my-4  border-bottom">
                            <div className="pb-3 col-sm-9 text-end">
                                <div className='d-flex justify-content-end align-items-center gap-2'>
                                    <button type="submit" className="btn btn-primary px-4">Show Report</button>
                                </div>
                            </div>
                        </div>
                    </form>
            </>)
    }

   const subAssemblyListJsx = () => {
    return <>
        <div ref={criteriaRef}
            style={{
                position: 'sticky',
                top: 0,
                background: 'white',
            }}>
            <DisplaySearchCriteria searchedElems={searchedElems} />
        </div>
        <table className="table table-sm table-bordered align-middle bg-white">
            <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                <tr className='text-center'>
                    <th style={{ width: "3%" }}>S.No</th>
                    <th style={{ width: "8%" }}>Sub Assembly Name</th>
                    <th style={{ width: "8%" }}>Code</th>
                    <th style={{ width: "8%" }}>Category</th>
                    <th style={{ width: "8%" }}>Site Name</th>
                    <th style={{ width: "10%" }}>Status</th>
                    <th style={{ width: "8%" }}>Serial Number</th>
                    <th style={{ width: "8%" }}>Manufacturer</th>
                    <th style={{ width: "8%" }}>Purchase Date</th>
                    <th style={{ width: "7%" }}>Purchase Price</th>
                    <th style={{ width: "7%" }}>Lifetime Hr Running</th>
                    <th style={{ width: "7%" }}>Lifetime Km Running</th>
                </tr>
            </thead>
            <tbody>
            {subAssemblyData.loading 
                ? <tr><td className='text-center' colSpan={13}><Loader /></td></tr>
                : ((subAssemblyData.items && subAssemblyData.items.length > 0) 
                    ? subAssemblyData.items.map((item, index) => {
                        
                        return <tr className='text-center' key={item.id || index}>
                            <td className='text-center'>{subAssemblyData.meta ? subAssemblyData.meta.from + index : index + 1}</td>
                            <td className='text-center'>{item.sub_assembly_name || "-"}</td>
                            <td className='text-center'>{item.code || "-"}</td>
                            <td className='text-center'>{item.category || "-"}</td>
                            <td className='text-center'>{item.site_name || "-"}</td>
                            <td className='text-center'>
                                <span>
                                    {item.status && item.status.color_code && (
                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faCircle} color={item.status.color_code} />
                                    )}
                                    {item.status ? item.status.name : "Inactive"}
                                </span>
                            </td>
                             <td className='text-center'>
                               {item.serial_number || "-"
                                }
                            </td>
                             <td className='text-center'>
                                {item.manufacturer_name || "-"}
                            </td>
                            <td className='text-center'>{item.purchase_date ? DateService.dateFormat(item.purchase_date) : "-"}</td>
                            <td className='text-center'>{item.purchase_price || "-"}</td>
                            <td className="text-center">
                                {item.life_time_hr_running  || "-"
                                }
                            </td>
                            <td className="text-center">
                                {item.life_time_km_running || "-"
                                }
                            </td>
                        </tr>
                    })
                    : <tr><td className='text-center' colSpan={13}>No Record</td></tr>)
            }
            </tbody>
        </table>
        <DisplayListPagination meta={subAssemblyData.meta} onPageChange={(e) => loadsubAssemblyData(e.selected + 1)} />
    </>
}

    const topRightHeaderJsx                 =   ()          =>  {
        return <>
            <div className="text-end mt-2">
                <button type="button" disabled={subAssemblyData.downloading || subAssemblyData.loading || formData.loading} className="btn btn-secondary" onClick={() => toggleFilterForm(!formData.show)} >
                    Change Filter
                </button>
                {subAssemblyData.data_loaded && <button type="button" disabled={subAssemblyData.downloading || subAssemblyData.loading || formData.loading} className="btn btn-secondary" onClick={reportDownloadHandler}>
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {subAssemblyData.downloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />}
                </button>}
                <button type="button"  className="btn btn-secondary mx-1" onClick={closeReport}>
                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close requisition" />
                </button>
            </div>
        </>
    }

    return  <ApplicationLayout>
        <PageHeader title="Sub Assembly Summary" name="Sub Assembly Summary Report" rightTopHeadingJsx={topRightHeaderJsx()}/>
        <div className="container-fluid pl5">
            <div className="page_containt row">
                <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                    <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide' ].join(" ")} >
                        {formData.loading ? <Loader /> : filterFormJsx()}
                    </div>
                    {subAssemblyData.show && subAssemblyListJsx()}
                </div>
            </div>
        </div>
    </ApplicationLayout>

});

export default SubAssemblySummaryReport;